import { API } from "@/main.js";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getPathwayDuctConfiguration({ commit }, pathwayUUID) {
    return new Promise((resolve, reject) => {
      API.pathwayMicroducts.getPathwayDuctConfiguration(
        pathwayUUID,
        resp => {
          resolve(resp.data.data);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },
}

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/Home/pathwayMicroducts.js